import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import NavBar from "../components/NavBar";
import "./RegisterLogin.css";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { loggedUser } from "../Redux/userSlice";
import { useDispatch } from "react-redux";

function RegisterLogin() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [newUser, setNewUser] = useState();
  const [errorRegister, setErrorRegister] = useState();
  const [logInUser, setLoginUser] = useState();
  const [errorLogin, setErrorLogin] = useState();

  const handleChangeRegister = (e) => {
    setNewUser({
      ...newUser,
      [e.target.name]: e.target.value,
    });
  };

  const handleChangeLogin = (e) => {
    setLoginUser({
      ...logInUser,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmitRegister = (e) => {
    e.preventDefault();
    const register = async () => {
      const response = await axios.post(
        `${process.env.REACT_APP_URL_BACK}/register`,
        newUser
      );

      if (response.data !== false) {
        dispatch(loggedUser(response.data));
        navigate("/");
      } else {
        setErrorRegister(response.data);
      }
    };

    register();
  };

  const handleSubmitLogin = async (e) => {
    e.preventDefault();

    const response = await axios({
      method: "post",
      url: `${process.env.REACT_APP_URL_BACK}/login`,
      data: logInUser,
    });
    if (response.data !== "error") {
      dispatch(loggedUser(response.data));
      navigate("/");
    } else {
      setErrorLogin(response.data);
    }
  };

  return (
    <>
      <NavBar />
      <div className="container mt-5">
        <div className="row d-flex justify-content-evenly mx-md-n5 mt-5">
          <div className="login border mt-5 p-3 col-10 col-md-5 px-md-5 ms-3 me-3">
            <h5>LOG IN</h5>
            <hr />
            <Form onSubmit={handleSubmitLogin}>
              <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Label>Email address</Form.Label>
                <Form.Control
                  type="email"
                  placeholder="Enter email"
                  name="email"
                  onChange={handleChangeLogin}
                  required={true}
                />
              </Form.Group>

              <Form.Group className="mb-3" controlId="formBasicPassword">
                <Form.Label>Password</Form.Label>
                <Form.Control
                  type="password"
                  placeholder="Password"
                  name="password"
                  onChange={handleChangeLogin}
                  required={true}
                />
              </Form.Group>
              <Form.Group className="mb-3" controlId="formBasicCheckbox">
                <Form.Check type="checkbox" label="Remember me" />
                <small>Forgot pasword?</small>
              </Form.Group>
              <Button variant="dark" type="submit">
                Submit
              </Button>
              {errorLogin === "error" ? (
                <p className="text-danger mt-3">Wrong credentials.</p>
              ) : (
                ""
              )}

              <p className="text-secondary mt-2">
                You can access as a user using the following credentials :
              </p>
              <ul className="text-start text-secondary">
                <li>Email: user@user.com</li>
                <li>Password: 123</li>
              </ul>
            </Form>
          </div>
          <div className="login border mt-5 p-3 col-10 col-md-5 px-md-5 ms-3 me-3 mb-5">
            <h5>REGISTER</h5>
            <hr />

            <Form onSubmit={handleSubmitRegister}>
              <Form.Group className="mb-3" controlId="formFirstName">
                <Form.Label>First Name *</Form.Label>
                <Form.Control
                  name="firstName"
                  type="text"
                  placeholder="Enter first name"
                  onChange={handleChangeRegister}
                  required={true}
                />
              </Form.Group>
              <Form.Group className="mb-3" controlId="formLastName">
                <Form.Label>Last Name *</Form.Label>
                <Form.Control
                  name="lastName"
                  type="text"
                  placeholder="Enter last name"
                  onChange={handleChangeRegister}
                  required={true}
                />
              </Form.Group>
              <Form.Group className="mb-3" controlId="formAddress">
                <Form.Label>Address *</Form.Label>
                <Form.Control
                  name="address"
                  type="text"
                  placeholder="Enter address"
                  onChange={handleChangeRegister}
                  required={true}
                />
              </Form.Group>
              <Form.Group className="mb-3" controlId="formLTelephone">
                <Form.Label>Telephone</Form.Label>
                <Form.Control
                  name="phone"
                  type="tel"
                  placeholder="Enter telephone"
                  onChange={handleChangeRegister}
                />
              </Form.Group>
              <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Label>Email address *</Form.Label>
                <Form.Control
                  name="email"
                  type="email"
                  placeholder="Enter email"
                  onChange={handleChangeRegister}
                  required={true}
                />
              </Form.Group>

              <Form.Group className="mb-3" controlId="formBasicPassword">
                <Form.Label>Password *</Form.Label>
                <Form.Control
                  name="password"
                  type="password"
                  placeholder="Password"
                  onChange={handleChangeRegister}
                  required={true}
                />{" "}
              </Form.Group>
              <Form.Group className="mb-3" controlId="formBasicCheckbox">
                <Form.Check type="checkbox" label="Remember me" />
                <small>Forgot pasword?</small>
              </Form.Group>

              <Button variant="dark" type="submit">
                Submit
              </Button>
              {errorRegister === false ? (
                <p className="text-danger mt-3">
                  There is already a user with this data.
                </p>
              ) : (
                ""
              )}
            </Form>
          </div>
        </div>
      </div>
    </>
  );
}

export default RegisterLogin;
